// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");

function getOrElse($$default, v) {
  return Belt_Option.getWithDefault((v == null) ? undefined : Caml_option.some(v), $$default);
}

exports.getOrElse = getOrElse;
/* No side effect */
